import { autocompleteCity, geocodeZip } from '@lib/geo-api'

export const mapAlgoliaCityHitToLocationOption = (city) => ({
  label: `${city.city}, ${city.state}`,
  placeName: `${city.city}, ${city.state}`,
  aroundLatLng: `${city._geoloc.lat}, ${city._geoloc.lng}`,
})

/**
 * Resolves typed location text to placeName + coordinates (hero Autocomplete freeSolo + Enter).
 */
export const resolveLocationOptionFromInput = async (rawInput, currentOptions = []) => {
  const q = (rawInput || '').trim()
  if (!q) return null

  const qLower = q.toLowerCase()
  const exact = currentOptions.find(
    (opt) => opt.placeName.toLowerCase() === qLower || opt.label.toLowerCase() === qLower,
  )
  if (exact) return exact

  const hits = await autocompleteCity(q, 10)
  if (hits.length > 0) return mapAlgoliaCityHitToLocationOption(hits[0])

  if (/^\d{5}(-\d{4})?$/.test(q)) {
    const zipFive = q.slice(0, 5)
    const geocodeResult = await geocodeZip(zipFive)
    if (geocodeResult?.lat != null && geocodeResult?.lng != null) {
      return {
        label: zipFive,
        placeName: zipFive,
        aroundLatLng: `${geocodeResult.lat}, ${geocodeResult.lng}`,
      }
    }
  }

  return null
}
